/**
 * Format date for display in Polish format.
 * Returns "-" for null/undefined dates.
 */
export function formatDate(date: Date | string | null | undefined): string {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleString('pl-PL');
}
